import { render, staticRenderFns } from "./IconSvgHeadSet.vue?vue&type=template&id=126f9e20&scoped=true&"
import script from "./IconSvgHeadSet.vue?vue&type=script&lang=js&"
export * from "./IconSvgHeadSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126f9e20",
  null
  
)

export default component.exports